import { useContext, useState } from "react";
import ExeManagement from "./ExeManagement/ExeManagement";
import AllowedTrades from "./AllowedTrades/AllowedTrades";
import ExeConfig from "./ExeConfig/ExeConfig";
import DetailedState from "./DetailedState/DetailedState";
import ServerTabBox from "src/Components/Tabbox/ServerTabBox";
import { ServerTabsContext } from "src/Layout/MasterPage";
import { useLocation } from "react-router-dom";

enum ActiveTab {
  ExeManagement = "ExecutionManagement",
  AllowedTrades = "AuthorizedTransactions",
  ExeConfig = "ExecutionSettings",
  DetailedState = "PartialExecutionStatus",
}

const DeltaHedgeExePhase3 = () => {
  const tabs = useContext(ServerTabsContext).deltaHedgeExePhase3;
  const location = useLocation();

  const getActiveTabUI = () => {
    const activeTab =
      new URLSearchParams(location.search).get("activeTab") || "ExecutionManagement";
    switch (activeTab) {
      case ActiveTab.ExeManagement:
        return <ExeManagement />;

      case ActiveTab.AllowedTrades:
        return <AllowedTrades />;

      case ActiveTab.ExeConfig:
        return <ExeConfig />;

      // case ActiveTab.Trade:
      //   return <Trade />;

      // case ActiveTab.Error:
      //   return <ErrorsTable />;

      case ActiveTab.DetailedState:
        return <DetailedState />;

      default:
        return <></>;
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 py-2 px-4 w-full">
      <div className="w-min">
        <ServerTabBox children={tabs?.tabs} />
      </div>
      {getActiveTabUI()}
    </div>
  );
};

export default DeltaHedgeExePhase3;
